import { api } from "./httpClient";

export const propertyService = {
  list() {
    return api("/v1/properties").then((res) => res?.content || []);
  },
  listForTenant(tenantId) {
    if (tenantId === null || tenantId === undefined || tenantId === "") {
      return api("/v1/properties").then((res) => res?.content || []);
    }
    return api(`/v1/properties?tenantId=${encodeURIComponent(tenantId)}`).then((res) => res?.content || []);
  },
  get(uuid) {
    return api(`/v1/properties/${encodeURIComponent(uuid)}`);
  },
  save(payload) {
    return api("/v1/properties", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },
  remove(uuid) {
    return api(`/v1/properties/${uuid}`, { method: "DELETE" });
  },
  restore(uuid) {
    return api(`/v1/properties/${uuid}/restore`, { method: "POST" });
  },
  listCountries() {
    return api("/v1/countries").then((res) => Array.isArray(res) ? res : []);
  },
  listStates(countryId) {
    return api(`/v1/states?countryId=${encodeURIComponent(countryId)}`).then((res) => Array.isArray(res) ? res : []);
  },
  listCities(stateId) {
    const url = stateId == null ? "/v1/cities" : `/v1/cities?stateId=${encodeURIComponent(stateId)}`;
    return api(url).then((res) => Array.isArray(res) ? res : []);
  },
  listAllCities() {
    return api("/v1/cities").then((res) => Array.isArray(res) ? res : []);
  },
};
